import { Injectable } from '@angular/core';
import { JsonUtils } from '@ird/shared-utils';

@Injectable()
export class DragDataService {
  private static readonly DATA_FORMAT = 'text/json';

  public hasDragData(event: DragEvent): boolean {
    if (event?.dataTransfer) {
      return event.dataTransfer.items?.length > 0;
    }
    return false;
  }

  public setDragData(event: DragEvent, dragData: unknown): DragEvent {
    const dragDataString: string = JSON.stringify(dragData);

    event.dataTransfer?.setData(DragDataService.DATA_FORMAT, dragDataString);
    event.dataTransfer?.setData(dragDataString, '');

    return event;
  }

  public getDragData(event: DragEvent): unknown {
    if (event?.dataTransfer) {
      const stringData = event.dataTransfer.getData(DragDataService.DATA_FORMAT);
      if (stringData) {
        return JSON.parse(stringData);
      }

      const item = this.findJsonKeyItem(event.dataTransfer.items);
      if (item) {
        return JSON.parse(item.type);
      }
    }

    return undefined;
  }

  // Browsers (e.g. Chromium's 'chromium/x-drag-id') and other libraries may add their own
  // items to the DataTransfer alongside ours, so the item count is not a reliable signal.
  // Instead, find the one item whose format name IS our JSON payload (see setDragData).
  private findJsonKeyItem(items: DataTransferItemList): DataTransferItem | undefined {
    return Array.from(items).find((item) => item.type !== DragDataService.DATA_FORMAT && JsonUtils.isJson(item.type));
  }
}
